if (!customElements.get('evrayne-integrated-purchase')) {
  customElements.define('evrayne-integrated-purchase', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.root = this.closest('product-info');
      this.main = this.form.querySelector('.product-form__submit');
      this.plan = this.querySelector('[name="selling_plan"]');
      this.quantity = this.root.querySelector('input[name="quantity"]');
      this.quantityGroup = this.quantity?.closest('[id^="Quantity-Form"]');
      if (this.quantityGroup) this.after(this.quantityGroup);
      this.gallery = this.root.querySelector('[data-ev-native-gallery]');
      this.media = this.root.querySelector('[data-ev-choice-media]');
      this.root.classList.add('ev-integrated-product');
      const nativePrice = this.root.querySelector('[id^="price-"]');
      if (nativePrice) nativePrice.hidden = true;
      const requested = new URLSearchParams(window.location.search).get('ev_offer');
      const requestedOption = [...this.querySelectorAll('[data-choice]')].find(option => option.dataset.choice === requested);
      if (requestedOption) requestedOption.querySelector('input[type="radio"]').checked = true;
      this.onChange = () => {
        this.updateChoice();
        const url = new URL(window.location.href);
        const key = this.selection()?.dataset.choice;
        if (key === 'one') url.searchParams.delete('ev_offer');
        else if (key) url.searchParams.set('ev_offer', key);
        window.history.replaceState(null, '', url);
      };
      this.onSubmit = event => {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.addSelection();
      };
      this.addEventListener('change', this.onChange);
      this.quantity?.addEventListener('change', this.onChange);
      this.quantity?.addEventListener('input', this.onChange);
      this.form.addEventListener('submit', this.onSubmit, true);
      this.updateChoice();
    }
    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      this.quantity?.removeEventListener('change', this.onChange);
      this.quantity?.removeEventListener('input', this.onChange);
      this.form?.removeEventListener('submit', this.onSubmit, true);
    }
    formatPrice(minor) {
      const example = this.dataset.moneyExample || '';
      const pattern = /1([^\d]*)234([^\d]*)567([^\d]*)89/;
      const match = example.match(pattern);
      if (match) {
        const absolute = Math.abs(Math.round(minor));
        const whole = Math.floor(absolute / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, match[1]);
        const decimal = match[3] + String(absolute % 100).padStart(2, '0');
        return example.replace(pattern, (minor < 0 ? '-' : '') + whole + decimal);
      }
      return new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency, currencyDisplay: 'code' }).format(minor / 100);
    }
    selection() { return this.querySelector('input[type="radio"]:checked')?.closest('[data-choice]'); }
    updateChoice() {
      const selected = this.selection();
      if (!selected) return;
      const combo = selected.dataset.combo === 'true';
      const monthly = selected.dataset.monthly === 'true';
      const quantity = combo ? 1 : Math.max(1, Number(this.quantity?.value) || 1);
      this.querySelectorAll('[data-choice]').forEach(option => {
        const active = option === selected;
        option.classList.toggle('is-selected', active);
        option.querySelector('.ev-integrated-option__body').hidden = !active;
        option.querySelector('input[type="radio"]').setAttribute('aria-expanded', String(active));
        const optionQuantity = option.dataset.combo === 'true' ? 1 : Math.max(1, Number(this.quantity?.value) || 1);
        option.querySelector('[data-choice-total]').textContent = optionQuantity === 1 ? option.dataset.priceLabel : this.formatPrice(Number(option.dataset.priceMinor) * optionQuantity);
        const quantityLabel = option.querySelector('[data-choice-quantity]');
        if (quantityLabel) { quantityLabel.hidden = optionQuantity === 1; quantityLabel.textContent = optionQuantity > 1 ? this.dataset.quantityLabel + ': ' + optionQuantity : ''; }

      });
      const price = quantity === 1 ? selected.dataset.priceLabel : this.formatPrice(Number(selected.dataset.priceMinor) * quantity);
      selected.querySelector('[data-choice-total]').textContent = price;
      const headingPrice = this.root.querySelector('[data-ev-current-price]');
      const headingLabel = this.root.querySelector('[data-ev-current-label]');
      if (headingPrice) headingPrice.textContent = price;
      if (headingLabel) headingLabel.textContent = selected.dataset.title + (monthly ? ' ' + this.dataset.monthLabel : '');
      this.plan.value = monthly && !combo ? '739188048256' : '';
      if (this.quantityGroup) this.quantityGroup.hidden = combo;
      if (this.gallery && this.media) {
        this.gallery.hidden = combo;
        this.media.hidden = !combo;
        if (combo && this.visualKey !== selected.dataset.choice) this.media.innerHTML = selected.querySelector('template[data-choice-visual]').innerHTML;
        this.visualKey = combo ? selected.dataset.choice : '';
      }
      const cta = this.dataset.addLabel;
      this.main.querySelector('span').textContent = cta;
      this.dispatchEvent(new CustomEvent('evrayne:purchase-change', { bubbles: true, detail: { price, label: combo ? this.dataset.routineLabel : monthly ? this.dataset.subscriptionLabel : selected.dataset.title, frequency: monthly ? this.dataset.monthLabel : '', cta } }));
    }
    async addSelection() {
      if (this.busy || this.main.disabled) return;
      const selected = this.selection();
      const combo = selected.dataset.combo === 'true';
      const quantity = combo ? 1 : Math.max(1, Number(this.quantity?.value) || 1);
      const unique = new Map();
      for (const line of JSON.parse(selected.querySelector('[data-choice-lines]').textContent)) unique.set(line.id, { ...line, quantity });
      this.busy = true;
      this.querySelector('fieldset').disabled = true;
      this.main.disabled = true;
      this.main.setAttribute('aria-disabled', 'true');
      this.main.querySelector('span').textContent = this.dataset.pending;
      const error = this.querySelector('[data-integrated-error]');
      error.hidden = true;
      try {
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [...unique.values()] })
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error('Selection not confirmed');
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'evrayne-integrated-purchase', cartData: result });
        window.location.assign(this.dataset.cartUrl);
      } catch (failure) {
        error.textContent = this.dataset.error;
        error.hidden = false;
        error.scrollIntoView({ block: 'center' });
        this.busy = false;
        this.querySelector('fieldset').disabled = false;
        this.main.disabled = false;
        this.main.removeAttribute('aria-disabled');
        this.updateChoice();
      }
    }
  });
}
